import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledChip, ChipType, LoadingComponent } from "@iventis/components";
import { SitemapRootNode, SitemapTreeBrowserContext, sitemapNodeComponents } from "@iventis/sitemaps";
import { useSitemapRoutingContext } from "@iventis/sitemaps/src/context/sitemap-routing-context";
import { Subtitle, styled } from "@iventis/styles";
import { useTreeBrowserInitialise, createInitialState, TreeBrowserComponent } from "@iventis/tree-browser";
import { useConstant, EMPTY_GUID } from "@iventis/utilities";
import { createRootIdFromProjectIdAndInstanceName, sitemapServices } from "./sitemap-api-functions";

export const SitemapTree: FunctionComponent<{ projectId: string; instanceName: string }> = ({ projectId, instanceName }) => {
    const treeId = useConstant(() => createRootIdFromProjectIdAndInstanceName(projectId, instanceName));
    const [{ tree, expandedNodeIds, isLoadingTree }, sitemapsTreeBrowserContext] = useTreeBrowserInitialise(
        createInitialState<SitemapRootNode>({
            mainNodeId: treeId,
            expandAllNodesOnLoad: false,
            treeId,
        }),
        sitemapServices,
        null
    );

    const { setSelectedSitemapId } = useSitemapRoutingContext();

    return (
        <>
            <div className="subtitle-controls-row">
                <Subtitle>Sitemaps</Subtitle>
                <StyledChip
                    label={
                        <>
                            <FontAwesomeIcon icon={["far", "plus"]} /> Add sitemap
                        </>
                    }
                    chipType={ChipType.PrimaryButton}
                    onClick={() => setSelectedSitemapId(EMPTY_GUID)}
                />
            </div>
            <StyledTreeContainer>
                {isLoadingTree ? (
                    <LoadingComponent />
                ) : (
                    <SitemapTreeBrowserContext.Provider value={sitemapsTreeBrowserContext}>
                        <TreeBrowserComponent<SitemapRootNode> node={tree} openNodes={expandedNodeIds} components={sitemapNodeComponents} />
                    </SitemapTreeBrowserContext.Provider>
                )}
            </StyledTreeContainer>
        </>
    );
};

const StyledTreeContainer = styled.div`
    overflow-y: auto;
    flex: 1 1 0;
`;
